/** @format */

import React, { useEffect, useState } from "react";
import { Subject, useGetSubjectsQuery } from "../../app/services/subjectApi";
import { useTranslation } from "react-i18next";
import { Outlet, useOutletContext, useParams } from "react-router-dom";
import { useLocale } from "../../i18n/hooks";
import ErrorPage from "../errorPage/ErrorPage";
import { Spinner } from "react-bootstrap";

type ContextType = { subject: Subject };

const SubjectPage: React.FC = () => {
  const { subject: subjectTitle } = useParams();
  const { t: _ } = useTranslation();
  const [subject, setSubject] = useState<Subject>();
  const locale = useLocale();

  const {
    data: subjects,
    isFetching: isLoadingSubjects,
    isSuccess,
    error,
  } = useGetSubjectsQuery();

  document.title = `${subjectTitle} - ${_("Educational Resources")} - ${_(
    "WJEC",
  )}`;

  useEffect(() => {
    if (!isLoadingSubjects && subjects) {
      const subjectObject = subjects.subjects.find(
        (subject: Subject) => subject.title[locale] === subjectTitle,
      );

      setSubject(subjectObject);
    }
  }, [isLoadingSubjects, subjects, subjectTitle, locale]);

  if (isSuccess && subject !== undefined) {
    return (
      <div className="SubjectPage h-100">
        {subject && <Outlet context={{ subject } satisfies ContextType} />}
      </div>
    );
  } else if (error !== undefined) {
    return (
      <ErrorPage
        statusMessage={_("This subject does not exist")}
        statusCode={404}
        actions={["report", "newResource"]}
      />
    );
  } else {
    return (
      <div className="position-absolute top-50 start-50 translate-middle">
        <Spinner />
      </div>
    );
  }
};

export function useSubject() {
  return useOutletContext<ContextType>();
}

export default SubjectPage;
